import { defineMessages } from "@/i18n";
import type { AgentAvatarStyleKey } from "@/lib/dicebear-styles";
import type { SoundType } from "@/lib/notification-sound";
import type { ThemeChoice } from "@/lib/theme";
import en from "./en";

export const settingsPreferencesMessages = defineMessages(
  "settings-preferences",
  en,
);

type Key = keyof typeof en;

/** How Settings names each theme, avatar style and sound. */
export const THEME_LABEL_KEY = {
  dark: "themeDark",
  light: "themeLight",
} as const satisfies Record<ThemeChoice, Key>;

export const AVATAR_STYLE_LABEL_KEY = {
  glass: "avatarStyleGlass",
  icons: "avatarStyleIcons",
} as const satisfies Record<AgentAvatarStyleKey, Key>;

export const SOUND_LABEL_KEY = {
  chime: "soundChime",
  ping: "soundPing",
  bell: "soundBell",
} as const satisfies Record<SoundType, Key>;
